var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isCsmMode
    ? _c("div", { staticClass: "csm-banner" }, [
        _c(
          "div",
          { staticClass: "container" },
          [
            _vm._v("\n    Сайт в режиме работы оператора КЦ\n\n    "),
            _c("ui-button", {
              staticClass: "csm-banner__button",
              attrs: {
                text: "Выйти",
                secondary: "",
                small: "",
                loading: _vm.isLoading
              },
              on: { click: _vm.exit }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }